var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "casino-group-container" },
    [
      !_vm.specialGroupType
        ? [
            _c("div", { staticClass: "group-header" }, [
              _vm.group.groupName
                ? _c("h2", { staticClass: "group-name" }, [
                    _vm._v(_vm._s(_vm.group.groupName))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showHideSeeAll
                ? _c(
                    "div",
                    { staticClass: "see-all" },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: {
                              name: "casino-page",
                              params: { slug: _vm.group.slug }
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Casino.See.All")))]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.group.groupId
              ? _c(
                  "div",
                  {
                    staticClass: "slider-container",
                    attrs: {
                      "data-gid": _vm.group.groupId,
                      id: "slider-container-" + _vm.group.groupId
                    }
                  },
                  [
                    _c("casino-slider", {
                      attrs: {
                        group: _vm.setGroupSliderItemLimit(_vm.group),
                        gamesByGroup: _vm.filterGamesInfoDataByGroup(
                          _vm.group.gameIds
                        )
                      },
                      on: { showHideSeeAll: _vm.updateSeeAllStatus }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.specialGroupType
        ? [
            _c(_vm.specialGroupType, {
              tag: "component",
              attrs: { group: _vm.group, groupRender: true }
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8bb84c18", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8bb84c18","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/igaming/partials/casinoGroup.vue
// module id = null
// module chunks = 